{
  "name": "react-seed",
  "version": "2.0.1",
  "repository": "git@bitbucket.org:bricksimple/react-seed.git",
  "author": "Scott Bouloutian <ScottBouloutian@gmail.com>",
  "license": "MIT",
  "scripts": {
    "start": "parcel --port 3000",
    "dev": "parcel src/index.html --port 3002",
    "dev-prod": "NODE_ENV=production parcel src/index.html --port 3002",
    "build": "parcel build src/index.html",
    "lint": "eslint --ext .js --ext .jsx src"
  },
  "dependencies": {
    "@date-io/date-fns": "1.x",
    "@emotion/react": "^11.10.5",
    "@emotion/styled": "^11.10.5",
    "@material-ui/core": "^4.11.0",
    "@material-ui/icons": "^4.11.2",
    "@material-ui/lab": "^4.0.0-alpha.57",
    "@material-ui/pickers": "^3.3.10",
    "axios": "^0.20.0",
    "chart.js": "^2.9.4",
    "date-fns": "^2.23.0",
    "formik": "^2.2.9",
    "moment": "^2.29.1",
    "prop-types": "^15.7.2",
    "react": "18.0.0",
    "react-chartjs-2": "^2.11.1",
    "react-dom": "18.0.0",
    "react-qr-code": "^2.0.11",
    "react-redux": "^7.2.3",
    "react-router-dom": "^5.2.0",
    "react-to-print": "^2.14.12",
    "react-toastify": "^9.1.1",
    "react-use-websocket": "^4.2.0",
    "redux": "^4.0.5",
    "redux-thunk": "^2.3.0",
    "rxjs": "^6.6.3",
    "yup": "^0.32.11"
  },
  "devDependencies": {
    "@babel/core": "^7.12.13",
    "@parcel/transformer-image": "^2.0.0-beta.2",
    "babel-eslint": "^10.1.0",
    "eslint": "^7.12.1",
    "eslint-config-airbnb": "^18.2.0",
    "eslint-config-prettier": "^6.15.0",
    "eslint-plugin-import": "^2.22.1",
    "eslint-plugin-jsx-a11y": "^6.4.1",
    "eslint-plugin-prettier": "^3.1.4",
    "eslint-plugin-react": "^7.21.5",
    "parcel": "^2.0.0-beta.1",
    "prettier": "^2.1.2"
  }
}
